import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ADMIN_ROLES = ["admin", "super_admin"];

const RouteGuard = ({ children, isProtected, adminOnly, superAdminOnly }) => {
  const { userInfo, authReady } = useSelector((state) => state.auth);
  const currentUser = userInfo;
  const isAuthenticated = Boolean(currentUser);

  if (!authReady) return null;

  if (isProtected && !isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (adminOnly && currentUser) {
    const userRole = currentUser.role;
    if (!ADMIN_ROLES.includes(userRole)) {
      return <Navigate to="/" replace />;
    }
  }

  if (superAdminOnly && currentUser?.role !== "super_admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (!isProtected && isAuthenticated) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default RouteGuard;
